import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import baseurl from './baseUrl'
const service = axios.create({
  baseURL: baseurl.http,
  timeout: 5000
})
service.interceptors.request.use(
  config => {
    config.headers['content-type'] = 'application/json; charset=utf-8'

    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code !== 0) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

        })
      }
      return res
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/util/request.js